import createCheckout from "../actions/create-checkout";
import updateLineItem from "../actions/update-item-checkout";
import addLineItem from "../actions/add-item-checkout";
import { navigate } from "gatsby";
import { Buffer } from "buffer";

const submitProduct = async (values, { props, setSubmitting, upsell }) => {
	let execute = null;
	if (!values.id) {
		alert("Please select an item.");
		setSubmitting(false);
		return;
	}

	if (values.id.includes("gid")) {
		const base64id = Buffer.from(values.id, "utf-8").toString("base64");
		values.id = `Shopify__ProductVariant__${base64id}`;
	}

	if (
		values.id ===
			"Shopify__ProductVariant__Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjYxODkzODIzNjk3OQ==" &&
		values.quantity > 3
	) {
		alert("You are only able to purchase 3 Tearribles Virus per customer.");
		setSubmitting(false);
		return;
	}

	// Send Facebook pixel data.
	// eslint-disable-next-line
	if (
		process.env.NODE_ENV === `production` &&
		typeof fbq === `function` &&
		values.dynamicProductData
	) {
		const { dynamicProductData, quantity } = values;
		dynamicProductData.value = String(
			(parseFloat(dynamicProductData.value) * 100 * quantity) / 100,
		);
		// eslint-disable-next-line
		fbq("track", "AddToCart", values.dynamicProductData);
	}

	if (props.cart.lineItems) {
		let currentLineItem = props.cart.lineItems.find((item) => {
			const valueID =
				typeof values.id === "string" && values.id.split("__").pop();
			return item.variant === valueID;
		});

		if (currentLineItem) {
			const quantity = currentLineItem.quantity + values.quantity;

			if (quantity >= 3 && currentLineItem.title.includes("Virus")) {
				alert(
					"You are only able to purchase 3 Tearribles Virus per customer.",
				);
				setSubmitting(false);
				return;
			}

			execute = () =>
				updateLineItem(
					currentLineItem,
					quantity,
					props.cart.id,
					props.setCart,
				);
		}
	}

	if (props.cart.id && !execute) {
		execute = () => addLineItem(values, props.cart.id, props.setCart);
	}

	if (!execute) {
		const { queryString } = props;
		execute = () => createCheckout(values, props.setCart, queryString);
	}

	return execute()
		.then((cart) => {
			let cartId;
			try {
				const cartUrl = new URL(cart.id);
				cartId = cartUrl.pathname.split("/").pop();
			} catch {
				return cart;
			}

			if (
				process.env.NODE_ENV === `production` &&
				window !== undefined &&
				window.TriplePixel &&
				values?.dynamicProductData?.content_ids?.length
			) {
				window.TriplePixel("AddToCart", {
					item: values.dynamicProductData.content_ids[0],
					q: values?.quantity,
					token: cartId,
				});
			}
		})
		.then(() => setSubmitting(false))
		.then(() => {
			if (!upsell) {
				navigate("/cart");
			}
			return null;
		});
};

export default submitProduct;
